import API from '@/api/index';

export async function loadAnalitycs (context, filter) {
    try {
      context.commit('setLoading', true, {root: true})
      const loginResponse = await API.login.loginRequest(user)
      localStorage.setItem('token', loginResponse.data['token'])
      context.commit('setUser', loginResponse)
      return loginResponse.status
    } catch (e) {
      context.commit('authError', e.message)
      return 400
    } finally {
      context.commit('setLoading', false, {root: true})
    }
  }